import { render, staticRenderFns } from "./payment-method.vue?vue&type=template&id=4514d9e6&scoped=true&"
import script from "./payment-method.vue?vue&type=script&lang=js&"
export * from "./payment-method.vue?vue&type=script&lang=js&"
import style0 from "./payment-method.vue?vue&type=style&index=0&id=4514d9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4514d9e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4514d9e6')) {
      api.createRecord('4514d9e6', component.options)
    } else {
      api.reload('4514d9e6', component.options)
    }
    module.hot.accept("./payment-method.vue?vue&type=template&id=4514d9e6&scoped=true&", function () {
      api.rerender('4514d9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/payment-method.vue"
export default component.exports